import { TablePagination } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { baseURL } from "../util/config";
import TablePaginationActions from "../util/Pagination";
import axios from "axios";
import noImage from "../assets/img/No_image.png";
import $ from "jquery";

const ManualPayment = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchPayments();

    
  }, []);

  const handleInfo = (userId) => {
    history.push({
      pathname: "/admin/user/userProfile",
      state: { userId },
    });
  };

  const fetchPayments = async () => {
    try {
      const res = await axios.get(`manualPayment/pending`);
      if (res.data.status) {
        setData(res.data.payments);
      }
    } catch (error) {
      console.error("Failed to fetch manual payments", error);
    }
  };

  const handleAction = async (id, status) => {
    let adminNotes = "";
    if (status === "REJECTED") {
      adminNotes = prompt("Enter reason for rejection:");
      if (adminNotes === null) return;
    } else {
      if (!window.confirm(`Are you sure you want to approve this payment?`)) return;
    }

    try {
      const res = await axios.post(`manualPayment/verify/${id}`, {
        status,
        adminNotes,
      });
      if (res.data.status) {
        alert(res.data.message);
        fetchPayments();
      } else {
        alert(res.data.message || "Action failed");
      }
    } catch (error) {
      alert("Verification failed.");
      console.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="row py-2">
        <div className="col-4">
          <h4 className="hostTitle">Pending Manual Payments</h4>
        </div>
        <div className="col-8">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </Link>
              </li>
              <li className="active">
                <a href={() => false}> Manual Payments </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row layout-top-spacing">
        <div id="tableDropdown" className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area">
              <div className="table-responsive">
                <table className="table text-center mb-4 table-striped">
                  <thead>
                    <tr className="text-center">
                      <th className="fw-bold">ID</th>
                      <th className="fw-bold">User</th>
                      <th className="fw-bold">UTR Number</th>
                      <th className="fw-bold">Amount</th>
                      <th className="fw-bold">Notes</th>
                      <th className="fw-bold">Screenshot</th>
                      <th className="fw-bold">Created At</th>
                      <th className="fw-bold">Info</th>
                      <th className="fw-bold">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      (rowsPerPage > 0
                        ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : data
                      ).map((tx, i) => (
                        <tr key={tx._id} className="text-center" style={{ verticalAlign: "middle" }}>
                          <td className="font-weight-bold">{page * rowsPerPage + parseInt(i) + 1}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <img
                                src={tx.userId?.image || noImage}
                                alt="user"
                                draggable="false"
                                className="table_image"
                                style={{ width: "40px", height: "40px", borderRadius: "50%", marginRight: "10px", cursor: "pointer" }}
                                onClick={() => handleInfo(tx.userId?._id)}
                                onError={(e) => { e.target.src = noImage; }}
                              />
                              <div className="text-left">
                                {tx.userId?.name || "Unknown"} <br />
                                <small className={(!tx.userId?.email || tx.userId?.email.toLowerCase() === "flirtzy@gmail.com") ? "" : "text-lowercase"}>
                                  {(!tx.userId?.email || tx.userId?.email.toLowerCase() === "flirtzy@gmail.com") ? "N/A" : tx.userId?.email}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td><span className="badge badge-secondary shadow-sm px-2 py-1">{tx.utr}</span></td>
                          <td><span className="badge badge-success shadow-sm px-3 py-2" style={{ fontSize: "14px" }}>{tx.amount}</span></td>
                          <td className="text-muted text-wrap" style={{ maxWidth: "150px" }}>{tx.notes || "-"}</td>
                          <td>
                            <a href={`${baseURL}storage/${tx.image}`} target="_blank" rel="noreferrer">
                              <img
                                src={`${baseURL}storage/${tx.image}`}
                                alt="proof"
                                draggable="false"
                                className="mx-auto"
                                style={{
                                  width: "100px",
                                  height: "60px",
                                  borderRadius: "8px",
                                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                  objectFit: "cover"
                                }}
                              />
                            </a>
                          </td>
                          <td>{dayjs(tx.createdAt).format("DD MMM YYYY, hh:mm A")}</td>
                          <td>
                            <button
                              className="btn btn-info mr-2"
                              onClick={() => handleInfo(tx.userId?._id)}
                            >
                              <i className="fa fa-info"></i>
                            </button>
                          </td>
                          <td>
                            <button
                              style={{ marginRight: "10px", marginBottom: "5px" }}
                              className="btn btn-success shadow-sm"
                              onClick={() => handleAction(tx._id, "APPROVED")}
                            >
                              <i className="fa fa-check mr-1"></i> Approve
                            </button>
                            <button
                              className="btn btn-danger shadow-sm"
                              onClick={() => handleAction(tx._id, "REJECTED")}
                            >
                              <i className="fa fa-times mr-1"></i> Reject
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No Pending Payments Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 100, { label: "All", value: data.length }]}
                  component="div"
                  count={data.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualPayment;
